import React, { useContext } from "react";
import AppCurrentLangContext from "@/contexts/appCurrentLang.context";
import AreFlagsDisplayedContext from "@/contexts/areFlagsDisplayed.context";
import transparentDivContext from "@/contexts/transparentDiv.context";
import styles from "./AppLangChoice.module.scss";
import {
  LANGUAGE_SETTINGS_KEYNAME_LOCAL_STORAGE,
  arrayLangsInApp,
} from "@/modules/i18n/i18n.consts";
import LinkMenu from "../ResponsiveMenu/LinkMenu/LinkMenu";
import { LangObject } from "@/modules/i18n/types/i18n.types";
import OutlineIcon from "@/assets/svg/arrow_drop_down/outline.svg";

const AppLangChoice = ({
  top = "3",
  topArrowMenu = "5",
  marginLeft = "0",
  lineHeightSelectAppLang = "25",
  topSelectAppLangFlags = "22",
}) => {
  const { appCurrentLang, setAppCurrentLang } = useContext(
    AppCurrentLangContext
  );
  const { isTransparentDivDisplayed, setIsTransparentDivDisplayed } =
    useContext(transparentDivContext);

  const { areFlagsDisplayed, setAreFlagsDisplayed } = useContext(
    AreFlagsDisplayedContext
  );

  const handleClick = (
    event: React.MouseEvent<HTMLDivElement>,
    lang: LangObject
  ) => {
    setIsTransparentDivDisplayed(false);
    setAppCurrentLang({
      locale: lang?.locale,
      translatedText: lang?.translatedText,
      pictureName: lang?.pictureName,
      langID: lang?.langID,
    });

    window.localStorage.setItem(
      LANGUAGE_SETTINGS_KEYNAME_LOCAL_STORAGE,
      lang?.locale
    );
  };

  const handleClickDisplayFlags = (event: React.MouseEvent<HTMLDivElement>) => {
    setAreFlagsDisplayed(!areFlagsDisplayed);
    setIsTransparentDivDisplayed(!isTransparentDivDisplayed);
  };

  const urlPicture = "/pictures/flags/" + appCurrentLang?.pictureName + ".png";

  // code d'easyflow pas utilisé ici, à voir si on en a besoin si le drapeau a du mal à se rerendre
  // Updating directly the DOM because DOm from SSR can be different from data in memory, and HTML can miss an update sometimes.
  if (typeof window !== "undefined") {
    const imageFlag = window.document.getElementById(
      "currentFlag"
    ) as HTMLImageElement;
    const urlFlagDOM = imageFlag?.src;

    if (
      urlFlagDOM !== urlPicture &&
      urlFlagDOM !== null &&
      urlFlagDOM !== undefined
    ) {
      imageFlag.src = urlPicture;
    }
  }

  return (
    <div
      className={`${styles.currentAppLang} h-5 w-14 py-1 px-4 hover:bg-slate-200 rounded-sm z-50`}
    >
      <div
        className={`${styles.currentLangFlag} flex h-full cursor-pointer w-12 items-center justify-center`}
        onClick={(e) => handleClickDisplayFlags(e)}
      >
        {appCurrentLang?.pictureName && (
          <img
            src={urlPicture}
            alt={appCurrentLang?.pictureName + " flag"}
            id="currentFlag"
            className="rounded-sm"
          />
        )}
        <div>
          <OutlineIcon />
        </div>

        {areFlagsDisplayed && (
          <div
            className={`${styles.setLangChoosing} ml-2 shadow-lg `}
            style={{
              lineHeight: lineHeightSelectAppLang + "px",
              top: topSelectAppLangFlags + "px",
            }}
          >
            {arrayLangsInApp.map((lang, index) => (
              <div
                className={`${styles.flagDropDown} `}
                key={index}
                onClick={(event) => handleClick(event, lang)}
              >
                <LinkMenu>
                  <img
                    src={"/pictures/flags/" + lang?.pictureName + ".png"}
                    alt={lang?.pictureName + " flag"}
                    className="rounded-sm"
                  />
                </LinkMenu>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AppLangChoice;
